import { IObservable, Subject } from '~/rage/utils';
import { RpcService } from '../RpcService';
import { VarsService } from '../VarsService';
import { ICatchRingService } from './catchRingServiceTypes';

export class CatchRingService implements ICatchRingService {
	private actionName = new Subject<string>('');

	constructor(
		private readonly rpc: RpcService,
		private readonly vars: VarsService,
	) {
		this.vars.get('catchRing:actionName', '').subscribe((value) => {
			this.actionName.next(value);
		});
	}

	public getActionName(): IObservable<string> {
		return this.actionName;
	}

	public async catch(success: boolean): Promise<void> {
		await this.rpc.invokeClient('catchRing:catch', { success });
	}

	public async exit(): Promise<void> {
		await this.rpc.invokeClient('catchRing:exit');
	}
}
